<div   class="mb-27 mct-flex mct-col mct-gap-27">
  <div>
    <p-checkbox #typeCheckbox binary="true" [(ngModel)]="selected" inputId="typeCheckbox" (onChange)="typeCheckedChanged()"> </p-checkbox>
    <label for="typeCheckbox">
      {{ ecomOptionType.Title }}
    </label>
  </div>
  <p-table [showGridlines]="true" #table [value]="ecomOptionType.EComItemOptions" (onRowReorder)="reorder()" *ngIf="selected">
    <ng-template pTemplate="sorticon" field="col.field" let-sortOrder>
      <SortAltIcon *ngIf="sortOrder === 0">
        <span><i class="p-sortable-column-icon pi pi-fw pi-sort-alt" aria-hidden="true"></i></span>
      </SortAltIcon>
      <SortAmountUpAltIcon *ngIf="sortOrder === 1" [styleClass]="'p-sortable-column-icon'">
        <span><i class="p-sortable-column-icon pi pi-fw pi-sort-amount-up-alt" aria-hidden="true"></i></span>
      </SortAmountUpAltIcon>
      <SortAmountDownIcon *ngIf="sortOrder === -1" [styleClass]="'p-sortable-column-icon'">
        <span><i class="p-sortable-column-icon pi pi-fw pi-sort-amount-down" aria-hidden="true"></i></span>
      </SortAmountDownIcon>
    </ng-template>
    <ng-template pTemplate="header">
      <tr>
        <th pSortableColumn="SortOrder" style="width: 75px">{{ 'ecommerce.item.options.sort-order' | translate | titlecase }}</th>
        <th>{{ 'ecommerce.item.options.option-label' | translate | titlecase }}</th>
        <th style="width: 130px">+{{ 'ecommerce.item.options.price' | translate | titlecase }}</th>
        <!-- <th style="width: 130px">+{{ 'ecommerce.item.options.shipping' | translate | titlecase }}</th> -->
        <th style="width: 63px"></th>
      </tr>
    </ng-template>
    <ng-template pTemplate="body" let-itemOption let-index="rowIndex">
      <tr [pReorderableRow]="index">
        <td style="width: 100px">
          <span class="mct-flex pi pi-bars mct-justify-center mct-items-center"  pReorderableRowHandle></span>
        </td>
        <td><input [(ngModel)]="itemOption.Title" class="form-control" /></td>
        <td style="width: 100px">
          <div class="p-inputgroup">
            <span class="atlas-input-addon">$</span>
            <input
              pInputText
              name="price"
              class="form-control"
              mask="separator.2"
              thousandSeparator=","
              [(ngModel)]="itemOption.AddToPrice"
            />
          </div>
        </td>
        <!-- <td style="width: 100px">
          <div class="p-inputgroup">
            <span class="atlas-input-addon">$</span>
            <input
              pInputText
              name="shippingPrice"
              class="form-control"
              mask="separator.2"
              thousandSeparator=","
              [(ngModel)]="itemOption.AddToShippingPrice"
            />
          </div>
        </td> -->
        <td style="width: 100px">
          <a (click)="delete(itemOption)"> {{ 'common.delete' | translate | ucfirst }} </a>
        </td>
      </tr>
    </ng-template>
  </p-table>

  <div class="mct-flex mct-row mct-justify-end mct-items-center"   *ngIf="selected">
    <button pButton type="button" class="atlas-btn atlas-btn-primary" (click)="addOption(ecomOptionType.OptionTypeId)">
      {{ 'ecommerce.item.options.add-option-button-label' | translate : { optionTitle: ecomOptionType.Title } | uppercase }}
    </button>
  </div>
</div>
<!-- <div class="mct-flex mct-col mct-gap-27" *ngIf="eCommerceItem"  >
  <div class="mct-flex mct-col mct-gap-27" *ngFor="let optionType of ecomOptionTypes"  >
    <p-table [showGridlines]="true" #table [value]="eCommerceItem.ItemOptions" (onRowReorder)="reorder(table, $event)" *ngIf="optionType.Selected">
      <ng-template pTemplate="sorticon" field="col.field" let-sortOrder>
        <SortAltIcon *ngIf="sortOrder === 0">
          <span><i class="p-sortable-column-icon pi pi-fw pi-sort-alt" aria-hidden="true"></i></span>
        </SortAltIcon>
        <SortAmountUpAltIcon *ngIf="sortOrder === 1" [styleClass]="'p-sortable-column-icon'">
          <span><i class="p-sortable-column-icon pi pi-fw pi-sort-amount-up-alt" aria-hidden="true"></i></span>
        </SortAmountUpAltIcon>
        <SortAmountDownIcon *ngIf="sortOrder === -1" [styleClass]="'p-sortable-column-icon'">
          <span><i class="p-sortable-column-icon pi pi-fw pi-sort-amount-down" aria-hidden="true"></i></span>
        </SortAmountDownIcon>
      </ng-template>
      <ng-template pTemplate="header">
        <tr>
          <th pSortableColumn="SortOrder" style="width: 75px">{{ 'ecommerce.item.options.sort-order' | translate | titlecase }}</th>
          <th>{{ 'ecommerce.item.options.option-label' | translate | titlecase }}</th>
          <th style="width: 130px">+{{ 'ecommerce.item.options.price' | translate | titlecase }}</th>
          <th style="width: 130px">+{{ 'ecommerce.item.options.shipping' | translate | titlecase }}</th>
          <th style="width: 63px"></th>
        </tr>
      </ng-template>
      <ng-template pTemplate="body" let-itemOption let-index="rowIndex">
        <tr [pReorderableRow]="index" *ngIf="itemOption.ItemOptionTypeId == optionType.OptionTypeId">
          <td style="width: 100px">
            <span class="mct-flex pi pi-bars mct-justify-center mct-items-center"  pReorderableRowHandle></span>
          </td>
          <td><input [(ngModel)]="itemOption.Title" class="form-control" /></td>
          <td style="width: 100px">
            <div class="p-inputgroup">
              <span class="atlas-input-addon">$</span>
              <input
                pInputText
                name="price"
                class="form-control"
                mask="separator.2"
                thousandSeparator=","
                [(ngModel)]="itemOption.AddToPrice"
              />
            </div>
          </td>
          <td style="width: 100px">
            <div class="p-inputgroup">
              <span class="atlas-input-addon">$</span>
              <input
                pInputText
                name="shippingPrice"
                class="form-control"
                mask="separator.2"
                thousandSeparator=","
                [(ngModel)]="itemOption.AddToShippingPrice"
              />
            </div>
          </td>
          <td style="width: 100px">
            <a (click)="delete(itemOption)"> {{ 'common.delete' | translate | ucfirst }} </a>
          </td>
        </tr>
      </ng-template>
    </p-table>

  </div>
</div> -->
